import { BoardOrder } from 'types';

export const getOrderInstructions = (orders: BoardOrder[]) =>
  orders?.map((order) => ({
    order: order['_id'],
    vote: '',
  }));
